export const EstadoUsuario = {
  Activo: 0,
  Inactivo: 1,
  Eliminado: 2,
  Bloqueado: 6,
};

export const TipoPerfil = {
  Carpeta: 1,
  Link: 2
};

export const TablaSeleccion = {
  TipoUser: 79,
  EstadoUser: 80,
  EstadoActivoInactivo: 81,
  TipoPerfil: 82,
  TipoOperacionCalculado: 83,
  SimboloOperacion: 84,
  SiNo: 16,
  TipoDocument: 2
};
